export default __webpack_public_path__ + "74acc99dcb784e85f28e63247f0ca426.jpg";